import gsap, { Power1, Power2, Power4 } from 'gsap'
import { qs, qsa, removeClass } from '../../utils'

import bidello from '../../bidello'
import home from '../../routes/home'

import world from '../../webgl/world/world'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import scroll from '../scroll/locomotiveScroll'

import sound from '../../sound'

const isMobile = window.innerWidth < 768

export const tl0 = () => {
  const trigger = qs('.l-home-1')
  const elements = [qs('h1', trigger), qs('h2', trigger), qs('.l-home__btn-wrapper', trigger)]
  const dummyObject = { value: 0 }

  const tl = gsap.timeline({
    paused: true,
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl0', progress: tl.progress() })
    },
    onComplete: () => {
      home.animating = false
      home.setScroll()
    }
  })

  tl
    .to(dummyObject, { value: 1, duration: 1.6, onUpdate: () => {
      if (world.materialSky) {
        world.materialSky.uniforms.uFade.value = dummyObject.value
      }
    }})
    .set(trigger, { autoAlpha: 1 })
    .fromTo(elements, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.6, ease: Power4.easeOut })

  return tl
}

export const tl1 = () => {
  const toggle = qsa('[data-toggle]')
  const trigger = qs('.l-home-1')
  const elements = [qs('h1', trigger), qs('h2', trigger), qs('.l-home__btn-wrapper', trigger)]

  const trigger2 = qs('.l-home-2')
  const element2 = qs('[data-scroll-target]', trigger2)

  const tl = gsap.timeline({
    paused: true,
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl1', progress: tl.progress() })
    },
    onComplete: () => {
      const logo = document.querySelector('[data-logo]')
      removeClass(logo, 'is-hidden')
      scroll.start()
    }
  })

  tl
    .add('start')
    .to(elements, {
      duration: 2,
      autoAlpha: 0
    })
    .from(element2, {
      duration: 2,
      autoAlpha:0
    })
    .fromTo(toggle, {
      autoAlpha: 0
    },{
      autoAlpha: 1,
      duration: 1.6,
      ease: Power4.easeOut
    }, 'start')

  return tl
}

export const tl2 = () => {
  const trigger = qs('.l-home-2')
  const element = qs('[data-scroll-target]', trigger)

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top top',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl2', progress: tl.progress() })
    }
  })

  tl.to(element, {
    autoAlpha: 0,
  })

  return tl
}

export const tl3 = () => {
  const trigger = qs('.l-home-3')
  const element = qs('[data-scroll-target]', trigger)

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl3', progress: tl.progress() })
    }
  })

  tl.from(element, {
    autoAlpha: 0,
  }, '+=1')

  tl.to(element, {
    autoAlpha: 0,
  })

  return tl
}

export const tl4 = () => {
  const trigger = qs('.l-home-4')
  const scroller = qs('ul', trigger)
  const sections = qsa('.l-home__slide', scroller)
  const targetSection = sections[1] || sections[0]

  const scrollAmountDt = scroller.getBoundingClientRect().width - (window.innerWidth - window.innerWidth / 4)
  const scrollAmountMb = scroller.getBoundingClientRect().width - window.innerWidth

  const scrollAmount = isMobile ? scrollAmountMb : scrollAmountDt

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      const { left } = scroller.getBoundingClientRect()
      const targetSectionLeft = targetSection.getBoundingClientRect().left

      const amountDt = targetSectionLeft < window.innerWidth / 4 ? (-left) - (window.innerWidth / 2) : 0
      const amountMb = targetSectionLeft < 0 ? (-left) - window.innerWidth : 0

      const amount = isMobile ? amountMb : amountDt

      document.documentElement.style.setProperty('--h-sticky', `${amount}px`)

      bidello.trigger({name:'tlProgress'}, { type: 'tl4', progress: tl.progress() })
    }
  })

  tl.from(trigger, {
    duration: 0.06,
    xPercent: 100
  }, '+=0.02')

  tl.to(scroller, {
    x: -scrollAmount
  })

  tl.to(scroller, {
    duration: 0.06,
    autoAlpha: 0,
    y: -16,
    ease: Power4.easeOut
  }, '-=0.02')

  return tl
}

export const tl5 = () => {
  const trigger = qs('.l-home-5')
  const element = qs('h3', trigger)
  const cta = qs('a', trigger)

  const height = element.getBoundingClientRect().height

  const amount = isMobile ?
    height + window.innerHeight / 1.5 :
    height + window.innerHeight / 2


  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl5', progress: tl.progress() })
    }
  })

  tl.from(element, {
    duration: 0.2,
    autoAlpha: 0,
    filter: 'blur(20px)'
  }, '+=1')

  tl.to(element, {
    duration: 1.4,
    y: -amount
  }, 'start-=0.1')

  tl.from(cta, {
    duration: 0.2,
    autoAlpha: 0,
  }, 'start-=0.3')

  tl.to(cta, {
    duration: 0.2,
    autoAlpha: 0,
  }, 'start')

  tl.to(element, {
    duration: 0.5,
    filter: 'blur(20px)',
    onStart: () => {
      sound.play('underwater')
    }
  }, `start-=${isMobile ? 1 : 0.9}`)

  return tl
}

export const tl6 = () => {
  const trigger = qs('.l-home-6')
  const elements = [qs('h5', trigger), qs('p', trigger)]

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl6', progress: tl.progress() })
    }
  })

  tl.from(elements, {
    duration: 0.2,
    y: 16,
    filter: 'blur(20px)',
    autoAlpha: 0
  }, '+=0.08')

  tl.set({}, {}, 0.7)

  return tl
}

export const tl7 = () => {
  const trigger = qs('.l-home-7')
  const elements = [qs('h5', trigger), qs('p', trigger)]

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      world.translatingMats[0].uniforms.uProgress.value = tl.progress()
      bidello.trigger({name:'tlProgress'}, { type: 'tl7', progress: tl.progress() })
    }
  })

  tl.from(elements, {
    duration: 0.2,
    y: 16,
    filter: 'blur(20px)',
    autoAlpha: 0
  }, '+=0.08')

  tl.set({}, {}, 0.7)

  return tl
}

export const tl8 = () => {
  const trigger = qs('.l-home-8')
  const elements = [qs('h5', trigger), qs('p', trigger)]

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl8', progress: tl.progress() })
    }
  })

  tl.from(elements, {
    duration: 0.2,
    y: 16,
    filter: 'blur(20px)',
    autoAlpha: 0
  }, '+=0.08')

  tl.set({}, {}, 0.7)

  return tl
}

export const tl9 = () => {
  const trigger = qs('.l-home-9')
  const elements = [qs('h5', trigger), qs('p', trigger)]

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      world.translatingMats[1].uniforms.uProgress.value = tl.progress()
      bidello.trigger({name:'tlProgress'}, { type: 'tl9', progress: tl.progress() })
    }
  })

  tl.from(elements, {
    duration: 0.2,
    y: 16,
    filter: 'blur(20px)',
    autoAlpha: 0
  }, '+=0.08')

  tl.set({}, {}, 0.7)

  return tl
}

export const tl10 = () => {
  const trigger = qs('.l-home-10')
  const elements = [qs('h5', trigger), qs('p', trigger)]

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl10', progress: tl.progress() })
    }
  })

  tl.from(elements, {
    duration: 0.2,
    y: 16,
    filter: 'blur(20px)',
    autoAlpha: 0
  }, '+=0.08')

  tl.set({}, {}, 0.7)

  return tl
}

export const tl11 = () => {
  const trigger = qs('.l-home-11')
  const elements = [qs('h5', trigger), qs('button', trigger)]

  const tl = gsap.timeline({
    scrollTrigger: {
      scroller: '[data-scroll-container]',
      trigger,
      scrub: true,
      start: 'top bottom',
      end: 'bottom bottom'
    },
    onUpdate: () => {
      bidello.trigger({name:'tlProgress'}, { type: 'tl11', progress: tl.progress() })
    }
  })

  tl.from(elements, {
    y: window.innerHeight - (window.innerHeight / 3)
  })

  return tl
}

export const setInitialAnimations = () => {
  return [tl0(), tl1()]
}

export const setAnimations = () => {
  return [tl2(), tl3(), tl4(), tl5(), tl6(), tl7(), tl8(), tl9(), tl10()]
}